import React, { memo } from 'react';
import { Clock } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function UrgencySection() {
  return <section className="py-20 md:py-28 px-6 bg-base" data-id="element-656">
      <div className="max-w-copy mx-auto" data-id="element-657">
        {/* Section label */}
        <FadeIn data-id="element-658">
          <div className="flex items-center gap-4 mb-16" data-id="element-659">
            <div className="h-px bg-border-accent flex-grow" data-id="element-660" />
            <span className="font-ui text-xs font-semibold tracking-widest uppercase text-accent-primary" data-id="element-661">
              ◆ Time Sensitive ◆
            </span>
            <div className="h-px bg-border-accent flex-grow" data-id="element-662" />
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-663">
          <h2 className="font-display text-3xl md:text-5xl font-bold text-text-primary mb-14 text-center leading-tight" data-id="element-664">
            Why Now
          </h2>
        </FadeIn>

        <div className="space-y-8 font-body text-lg leading-relaxed text-text-secondary" data-id="element-665">
          <FadeIn delay={0.15} data-id="element-666">
            <div className="flex items-start gap-4 bg-elevated border border-accent-primary/30 rounded-sm p-6" data-id="element-667">
              <Clock className="w-5 h-5 text-accent-primary mt-1 flex-shrink-0" data-id="element-668" />
              <p className="text-text-primary font-medium text-xl m-0" data-id="element-669">
                This is a limited memorial edition. It is not a permanent
                fixture in our catalog.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-670">
            <div className="space-y-6" data-id="element-671">
              <p data-id="element-672">
                While the conversation about what happened is still alive — this
                is the moment to have the complete document.
              </p>
              <p data-id="element-673">
                Historical archives carry more weight when accessed close to the
                moment they document. The story is still being written. This
                book captures it while the ink is still fresh.
              </p>
            </div>
          </FadeIn>

          {/* Emotional anchor */}
          <FadeIn delay={0.25} data-id="element-674">
            <div className="border-l-4 border-accent-primary bg-surface p-6 md:p-8 my-12" data-id="element-675">
              <p className="font-display text-xl md:text-2xl italic text-text-primary leading-relaxed m-0" data-id="element-676">
                Once this edition closes — it closes.
              </p>
            </div>
          </FadeIn>

          {/* CTA in card */}
          <FadeIn delay={0.3} data-id="element-677">
            <div className="flex flex-col items-center mt-8 bg-surface border border-border-default rounded-sm p-10 text-center" data-id="element-678">
              <p className="font-display text-xl italic text-text-secondary mb-6" data-id="element-679">
                Don't wait for the next news cycle to remind you.
              </p>
              <Button href="#offer" className="w-full md:w-auto text-sm md:text-base" data-id="element-680">
                Claim Your Copy Before It Closes &rarr;
              </Button>
              <p className="font-ui text-xs text-text-muted mt-4 tracking-wide" data-id="element-681">
                Memorial edition. Limited availability.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}